import { render, staticRenderFns } from "./GridFlex.vue?vue&type=template&id=5aefa4a2&"
import script from "./GridFlex.vue?vue&type=script&lang=js&"
export * from "./GridFlex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports